module.exports = __webpack_public_path__ + "static/media/twitterBlank.ea54985a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/social/twitterBlank.svg
// module id = 615
// module chunks = 0